import React from "react";
import { buildQuerySummary } from "@coveo/headless";
import classNames from "classnames";
import { useCoveoController } from "./utils";
import { ResultsList } from "./ResultsList";
import { QuerySummary } from "./QuerySummary";
import { GeneratedAnswer } from "./generatedAnswer/GeneratedAnswer";
import { Notifications } from "./Notifications";

export const ResultsSection = () => {
  const flags = window.scConfig.flags;
  const showGenAiAnswers = flags && flags.support_center_coveo_gen_ai;
  const { state } = useCoveoController(
    (headlessEngine) => buildQuerySummary(headlessEngine),
    "QuerySummary"
  );

  const { isLoading } = state;

  return (
    <div className={classNames("results-section columnt", { loading: isLoading })}>
      <QuerySummary />
      <Notifications />
      {showGenAiAnswers ? <GeneratedAnswer /> : null}
      <ResultsList />
    </div>
  );
};
